import { useState } from 'react'
import { bool, node, arrayOf, shape, number, func, object, oneOf } from 'prop-types'
import { Tabs, Tab, Box, useMediaQuery, useTheme } from '@mui/material'
import { sx } from 'utils'

BaseTabs.propTypes = {
  tabs: arrayOf(shape({
    titolo: node.isRequired,
    contenuto: node.isRequired,
    disabled: bool,
  })).isRequired,

  // Passando queste 2 prop, il tab visibile può essere 
  // controllato completamente dal padre
  indiceTabVisibile: number,
  onChangeTab: func,
  smallMode:  oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  propsTitoloTab: object,
  propsContenutoTab: object
}

export default function BaseTabs(props) {
  const {
    tabs,
    indiceTabVisibile: indiceTabVisibile_Prop,
    onChangeTab,
    propsTitoloTab,
    propsContenutoTab,
    smallMode,
    ...restProps
  } = props

  const [
    indiceTabVisibile_StatoInterno, setIndiceTabVisibile_StatoInterno
  ] = useState(indiceTabVisibile_Prop ?? 0)

  // Tab visibile impostato dal padre vince sullo stato interno
  const indiceTabVisibile_Definitivo = indiceTabVisibile_Prop ?? indiceTabVisibile_StatoInterno

  const { breakpoints } = useTheme()
  const schermoStretto = useMediaQuery(breakpoints.down(smallMode))
  const isSmallStyle = smallMode && schermoStretto

  const titoloAggiuntivo = (index,tot, titolo) => isSmallStyle ? <Box display='flex' alignItems='center'>{titolo}<>{index+1}/{tot}</></Box> : titolo 
  const mostraTab = (index, currentIndex) => isSmallStyle ? index === currentIndex: true 

  return (
    <>
      <Tabs
        value={indiceTabVisibile_Definitivo}
        onChange={(_, nuovoIndice) => {
          setIndiceTabVisibile_StatoInterno(nuovoIndice)
          onChangeTab?.(nuovoIndice)
        }}
        indicatorColor='primary'
        {...restProps}
      >
        {tabs.map(({ titolo, disabled }, indice) =>
          <Tab
            label={titoloAggiuntivo(indice, tabs.length, titolo)}
            disableRipple
            key={indice}
            {...(disabled && { disabled })}
            {...propsTitoloTab}
            {...sx(propsTitoloTab, { maxWidth: 'inherit' , display: mostraTab(indice,indiceTabVisibile_Definitivo)? 'block' : 'none' })}
          />
        )}
      </Tabs>

      {tabs.map(({ contenuto }, indice) =>
        <TabPanel
          indice={indice}
          indiceTabVisibile={indiceTabVisibile_Definitivo}
          key={indice}
          {...propsContenutoTab}
        >
          {contenuto}
        </TabPanel>
      )}
    </>
  )
}

function TabPanel(props) {
  const {
    children,
    indiceTabVisibile,
    indice,
    propsBox,
    ...other
  } = props

  return (
    <div
      hidden={indiceTabVisibile !== indice}
      {...other}
    >
      <Box padding={3} {...propsBox}>
        {children}
      </Box>
    </div>
  )
}
